<script setup lang="ts">
import { cardKey, cardMetaKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import { isDependency, isNote, isRisk, isWorkitem } from "@/model/stickyType";
import { injectStrict } from "@/utils/vue";

import DependencyFooter from "./internal/DependencyFooter/DependencyFooter.vue";
import NoteFooter from "./internal/NoteFooter/NoteFooter.vue";
import RiskFooter from "./internal/RiskFooter/RiskFooter.vue";
import WorkItemFooter from "./internal/WorkItemFooter/WorkItemFooter.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);
const cardMeta = injectStrict(cardMetaKey);
</script>

<template>
  <div :class="['sticky-note-footer', { dependency: isDependency(card), note: isNote(card) }]">
    <div
      v-if="cardMeta.levelOfDetails > 1 || board.state.finishedTicks > 1"
      v-show="cardMeta.levelOfDetails > 1"
    >
      <WorkItemFooter v-if="isWorkitem(card)" />
      <RiskFooter v-if="isRisk(card)" />
      <NoteFooter v-if="isNote(card)" />
      <DependencyFooter v-if="isDependency(card)" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sticky-note-footer {
  height: 36px;
  padding: 8px;
  max-width: 100%;
  overflow: hidden;

  &.dependency {
    height: 64px;
  }

  // overflow: visible is necessary for reactions animation
  &.note {
    overflow: visible;
  }
}
</style>
